import { render, staticRenderFns } from "./mgmtGroup.vue?vue&type=template&id=503ff589&scoped=true"
import script from "./mgmtGroup.vue?vue&type=script&lang=js"
export * from "./mgmtGroup.vue?vue&type=script&lang=js"
import style0 from "./mgmtGroup.vue?vue&type=style&index=0&id=503ff589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503ff589",
  null
  
)

export default component.exports